var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.99958 0.969238L17.6797 9.02034L16.3196 10.4866L9.99958 4.62464V23.6665H7.99958V4.62464L1.67968 10.4866L0.31958 9.02034L8.99958 0.969238Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"18","height":"24","viewBox":"0 0 18 24"};

module.exports = Arrow;

Arrow.default = Arrow;
